<div class="border-[#C4C4C4] border border-solid p-[10px] flex items-center gap-1">
  <ng-content select="[prepend]"></ng-content>
  <code data-test-id="snippet" class="whitespace-nowrap text-grey-600 text-sm text-clip overflow-hidden">{{
    snippet
  }}</code>
  <ng-content select="[append]"></ng-content>
</div>
